import { render, staticRenderFns } from "./cadastroBairro.vue?vue&type=template&id=f474d9e6"
import script from "./cadastroBairro.vue?vue&type=script&lang=js"
export * from "./cadastroBairro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports